import React from "react";
import styled from "styled-components";

const StripeTrustBadge = ({
  variant = "footer",
  text,
  className = "",
  showLogo = true,
}) => {
  const defaultCopy = {
    footer: "Secure payments powered by Stripe.",
    pricing: "All transactions are processed securely via Stripe.",
    checkout:
      "Payments are handled by Stripe. We never store your card details.",
  }[variant];

  const Container =
    variant === "pricing" ? PricingBadgeContainer : BadgeContainer;

  return (
    <Container className={className} aria-label="Payment security notice">
      {showLogo && (
        <StripeLogo>
          <svg aria-hidden="true" width="40" height="16" viewBox="0 0 40 16">
            <rect width="40" height="16" rx="3" fill="#635BFF" />
            <text
              x="50%"
              y="50%"
              dominantBaseline="middle"
              textAnchor="middle"
              fontFamily="system-ui, -apple-system, Segoe UI, Roboto, Inter, Arial"
              fontSize="8"
              fontWeight="700"
              fill="white"
            >
              Stripe
            </text>
          </svg>
        </StripeLogo>
      )}
      <BadgeText>{text || defaultCopy}</BadgeText>
    </Container>
  );
};

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: var(--color-text-light);
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 0.7rem;
    gap: 0.375rem;
  }
`;

const PricingBadgeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: white;
  opacity: 0.8;
  font-family: var(--font-secondary);
  margin-top: 1rem;

  @media (max-width: 768px) {
    font-size: 0.8rem;
    gap: 0.375rem;
  }
`;

const StripeLogo = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

const BadgeText = styled.span`
  line-height: 1.4;
`;

export default StripeTrustBadge;
